import type { ModeCollectionIds } from "./adminMode";

export type CallableWorkspaceParams = {
  accountId?: string;
  spaceId?: string;
  eventId?: string;
};

export function toCallableWorkspaceParams(
  ids: ModeCollectionIds
): CallableWorkspaceParams {
  return {
    accountId: ids.account?.accountId,
    spaceId: ids.space?.spaceId,
    eventId: ids.event?.eventId,
  };
}
